import BmtInboxHealthAPI from '../../api/bmtInboxHealth';

const POLL_INTERVAL_MS = 30000; // 30s — alinhado com o cache de 30s do backend

export const state = {
  // { [inbox_id]: { inbox_id, instance_name, status, inbox_name } }
  byInboxId: {},
  lastFetchedAt: null,
  isPolling: false,
  pollTimer: null,
};

export const getters = {
  // Expoe o mapa inteiro; os componentes derivam por inbox_id em computeds locais.
  // (getter method-style via useMapGetter nao re-dispara de forma confiavel)
  byInboxId: $state => $state.byInboxId,
};

export const actions = {
  async fetch({ commit }) {
    try {
      const { data } = await BmtInboxHealthAPI.getHealth();
      commit('SET_HEALTH', data.data || []);
    } catch (error) {
      // Silencioso: se a Evolution estiver fora, a UI nao deve quebrar.
      // O proximo poll tenta de novo.
    }
  },
  startPolling({ state: $state, commit, dispatch }) {
    if ($state.isPolling) return;
    commit('SET_POLLING', true);
    dispatch('fetch'); // primeira chamada imediata
    const timer = setInterval(() => dispatch('fetch'), POLL_INTERVAL_MS);
    commit('SET_POLL_TIMER', timer);
  },
  stopPolling({ state: $state, commit }) {
    if ($state.pollTimer) clearInterval($state.pollTimer);
    commit('SET_POLL_TIMER', null);
    commit('SET_POLLING', false);
  },
};

export const mutations = {
  SET_HEALTH($state, list) {
    const map = {};
    list.forEach(item => {
      map[item.inbox_id] = item;
    });
    $state.byInboxId = map; // novo objeto => dispara reatividade nos computeds
    $state.lastFetchedAt = new Date();
  },
  SET_POLLING($state, isPolling) {
    $state.isPolling = isPolling;
  },
  SET_POLL_TIMER($state, timer) {
    $state.pollTimer = timer;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
